import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { Card, CardBody } from "reactstrap";

import PageLoader from "../Common/PageLoader";
import ContentWrapper from "../Layout/ContentWrapper";
import { readStoredUser } from "../../navigation-v2/app/browserAdapters";
import { evaluateLegacyRouteAccess, legacyRouteForbiddenDescriptionKey } from "./legacyRouteAccess";

// Même lecture du compte que la recherche globale Classique (LegacyGlobalNavigationSearch).
const readViewer = (zooId) => {
  const stored = typeof window === "undefined" ? {} : readStoredUser(window.localStorage);
  return stored.zooId || !zooId ? stored : { ...stored, zooId };
};

/**
 * Garde des routes Classique : une adresse d'administration du parc ou d'outil
 * AKONGO ouverte sans le droit correspondant affiche « Accès refusé » au lieu de
 * monter la vue. Les autres routes passent sans changement.
 */
export function LegacyRouteGuard({ children, location, t, zoo }) {
  const access = evaluateLegacyRouteAccess({
    pathname: location?.pathname,
    viewer: readViewer(zoo?.zooId),
    zoo,
  });
  if (access.status === "open") return children;
  if (access.status === "pending") return <PageLoader />;
  return (
    <ContentWrapper>
      <Card
        role="alert"
        style={{ borderRadius: "12px", border: "none", boxShadow: "0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)" }}
      >
        <CardBody style={{ backgroundColor: "white", padding: "1.5rem" }}>
          <h4 className="mb-2" style={{ color: "#5a5c69" }}>
            <i className="fas fa-lock mr-2"></i>
            {t("common.accessDenied")}
          </h4>
          <p className="mb-0">{t(legacyRouteForbiddenDescriptionKey(access.accessKey))}</p>
        </CardBody>
      </Card>
    </ContentWrapper>
  );
}

LegacyRouteGuard.propTypes = {
  children: PropTypes.node,
  location: PropTypes.shape({ pathname: PropTypes.string }),
  t: PropTypes.func.isRequired,
  zoo: PropTypes.object,
};

const mapStateToProps = (state) => ({ zoo: state.zoo });

export default connect(mapStateToProps)(withNamespaces("translations")(LegacyRouteGuard));
